// jve-5-1: the API-scoped role catalogue for service accounts, shared by the create wizard and the
// detail/edit screen (single source — "verify + expand catalogue", not "introduce multi-role": the
// backend already supports multiple authorities per account). Values are the Spring Security
// authorities granted verbatim by our own RBAC (jve-1-5): the minted token carries these strings
// unprefixed, so each value must be EXACTLY what the backend's @PreAuthorize checks — the foster
// endpoints check `foster-platform-read` / `foster-platform-write`, not a ROLE_-style spelling.
// ApiRoleCatalogueWiringTest (api/) fails when a value here is checked nowhere in the backend.
// When the backend grows a roles endpoint this becomes a fetch.
export interface ApiRole {
  value: string;
  label: string;
}

export const AVAILABLE_ROLES: ApiRole[] = [
  { value: "ROLE_PROVISIONING", label: "Provisioning" },
  { value: "foster-platform-read", label: "Foster-platform — lezen" },
  { value: "foster-platform-write", label: "Foster-platform — schrijven" },
];

/** Friendly label for an authority, falling back to the raw code for anything outside the catalogue. */
export function roleLabel(value: string): string {
  return AVAILABLE_ROLES.find((r) => r.value === value)?.label ?? value;
}
